import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateContactFileRequestsQueries } from './useContactFileRequestsQuery';
import { CONTACT_FILES_QUERY_KEY } from './useContactFilesQuery';

interface UseDeleteSharedFileMutationOptions {
	onSuccess?: () => void;
	onError?: () => void;
}

interface DeleteSharedFileMutationParams {
	id: string;
	deleteSourceFile: boolean;
	contactId: string;
}

export function useDeleteSharedFileMutation({ onSuccess, onError }: UseDeleteSharedFileMutationOptions = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ id, deleteSourceFile }: DeleteSharedFileMutationParams) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `SharedFile/${encodeURIComponent(id)}`,
					queryParams: { deleteSourceFile },
				}),
				'DELETE'
			);
		},
		onSuccess: () => {
			onSuccess?.();
		},
		onError,
		// A failed delete may still have removed the file, so refresh either way.
		onSettled: (_, __, { contactId }) => {
			queryClient.invalidateQueries({ queryKey: [CONTACT_FILES_QUERY_KEY, contactId] });
			invalidateContactFileRequestsQueries({ contactId });
		},
	});
}
